$(function() {
  "use strict";

  const slider_options_defaults = {
    speed: 400,
    grabCursor: true,
    keyboardControl: true
  };

  $(".swiper-container-pm").each(function() {
    var $slider_container = $(this);
    var slider_opts = Object.create(slider_options_defaults);
    if ($slider_container.hasClass("box--featured-events")) {
      slider_opts.loop = true;
      slider_opts.arrows = true;
      slider_opts.prevButton = ".arrow-prev";
      slider_opts.nextButton = ".arrow-next";
      slider_opts.pagination = ".swiper-pagination";
    }

    if ($slider_container.hasClass("related-content-slider")) {
      var uuid = $slider_container.attr("data-uuid");
      slider_opts.loop = false;
      slider_opts.slidesPerView = 4;
      slider_opts.slidesPerRow = 1;
      slider_opts.slidesPerGroup = 4;
      slider_opts.autoHeight = true;
      slider_opts.breakpoints = {
        480: {
          slidesPerView: 1,
          slidesPerGroup: 1
        },

        768: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        960: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        1080: {
          slidesPerView: 4,
          slidesPerGroup: 4
        }
      };
      slider_opts.slidesPerColumnFill = "row";
      slider_opts.prevButton = ".arrow-prev-" + uuid;
      slider_opts.nextButton = ".arrow-next-" + uuid;
      slider_opts.pagination = ".swiper-pagination";
    }

    if ($slider_container.hasClass("blog-gallery")) {
      slider_opts.loop = true;
      slider_opts.prevButton = ".arrow-prev";
      slider_opts.nextButton = ".arrow-next";
      slider_opts.pagination = ".swiper-pagination";
      slider_opts.slidesPerView = 1;
    }

    //initialise each slider
    var this_slider = new Swiper($slider_container, slider_opts);

    // $slider_container.on('beforeChange', function(event, slick, currentSlide){
    //   //pause video on slide change
    //   var $slide_obj = $slider_container.find("[data-slick-index='" + currentSlide + "']");
    //   var $video = $slide_obj.find('video');
    //   if(typeof $video != 'undefined' && $video.length) {
    //     $video.get(0).pause();
    //   }
    // });

    //  $slider_container.on('init', function(event){
    //   //play video on carousel load if available
    //   var $slide_obj = $slider_container.find("[data-slick-index='0']");
    //   var $video = $slide_obj.find('video');
    //   if(typeof $video != 'undefined' && $video.length) {
    //     $video.get(0).play();
    //   }

    //initialise each slider
  });
});
